import axios from "axios"

const apiUrl = process.env.REACT_APP_API_URL;

export const handlePostApis = async (url, data) => {
    try {
        const res = await axios.post(`${apiUrl}${url}`, data, {
            withCredentials: true
        })
        return res;
    }
    catch (err) { console.log('error in Api', err); return {
        data : {
        status: false,
        message: err.response?.data?.message || 'An unexpected error occurred.',
        }
    };}
}
export const handleGetApis = async (url) => {
    try {
        const res = await axios.get(`${apiUrl}${url}`, {withCredentials: true})
        return res;
    }
    catch(err) { console.log('error in api', err); }
}
export const handleDeleteApis = async (url, data) => {
    try {
        const res = await axios.delete(`${apiUrl}${url}`, {data,
            withCredentials: true
        })
        return res;
    }
    catch (err) { console.log(err, 'error in api'); return{
         status: false,
        message: err.response?.data?.message || 'An unexpected error occurred.',
    } }
}